import React from "react";

import { SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../toolbars/SaveWithCancelToolbar';
import { ApproveExternalWithCancelToolbar } from "components/toolbars/ApproveExternalWithCancelToolbar";
import { isExternalNotApproved } from "utils/checker/entity";

export const SimpleFormAdv = (props) => {
    const ToolbarComp = props.toolbarComp ?? 
        (
            isExternalNotApproved(props.record.state) ? 
                ApproveExternalWithCancelToolbar : 
                SaveWithCancelToolbar
        );

    const onFormChange = (a, b, c) => {};

	return <SimpleForm
    onChange={onFormChange}
        submitOnEnter={false}
        redirect="list"
        toolbar={<ToolbarComp hasShow={props.hasShow} {...props.toolbarCompProps} />}
        {...props}        
    />;
};
